// extracted by mini-css-extract-plugin
export default {"header":"Home_header__jgN9+","image":"Home_image__dxFyw"};